/* global __BOLT_ON_MODULES__ */
import React from "react"
import fetch from "isomorphic-unfetch"
import { STORE_MODULE_DATA, MODULE_ORDER } from "../constants"
import ModuleIcon from "../ModuleIcons"

export const storeModuleData = (moduleData) => ({
  moduleData: moduleData.sort(
    (a, b) =>
      MODULE_ORDER.indexOf(`${a.path.slice(1)}`) <
      MODULE_ORDER.indexOf(`${b.path.slice(1)}`)
  ),
  type: STORE_MODULE_DATA,
})

const BoltOnModules = Object.values(__BOLT_ON_MODULES__)
export const isJson = (value) => {
  try {
    JSON.parse(value)
  } catch (e) {
    return false
  }
  return true
}
export default (dispatch) =>
  new Promise((resolve) => {
    Promise.all(
      BoltOnModules.map(
        (module) =>
          new Promise((res, reject) => {
            fetch(`/private/shared/${module}/index.json`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
            }).then((el) => {
              const { status } = el
              const reader = el.body.getReader()

              reader.read().then(({ value }) => {
                const strValue = value
                  ? String.fromCharCode.apply(null, value)
                  : null

                const data = isJson(strValue)
                  ? JSON.parse(strValue)
                  : {
                      path: "not-found",
                    }

                if (status < 400)
                  res({
                    WhiteIcon: () => (
                      <ModuleIcon
                        module={module}
                        dispatch={dispatch}
                        iconName="whiteIcon"
                      />
                    ),
                    LargeIcon: () => (
                      <ModuleIcon
                        module={module}
                        dispatch={dispatch}
                        iconName="largeIcon"
                      />
                    ),
                    ...data,
                  })
                else {
                  console.error(
                    `Module retrieval for module ${module} failed with status - ${status}`
                  )
                  reject()
                }
              })
            })
          })
      )
    )

      .then((response) =>
        storeModuleData(response.filter((mod) => mod.path !== "not-found"))
      )
      .then(dispatch)
      .then(resolve)
      .catch(console.error)
  })
